import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';

@Injectable({
  providedIn: 'root'
})
export class ReporteProductividadService {
  private API_URL;

  constructor(
    private http: HttpClient,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
   }

  reportProductivityData(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Reporte/PaginadoReporteProductividad?PageNumber=${entry.numeroPagina}&PageSize=12`, entry).pipe(
			retry(2)
		);
	}

  reportProductivityExport(entry: any){
    return this.http.post<any>(`${this.API_URL}/Reporte/GenerarExportarReporteProductividad`,
    entry,
    { observe: 'response'}).pipe(retry(2));
  }
}
